import {Component, effect, inject} from '@angular/core';
import {PromoBannerComponent} from '../promo-banner/promo-banner.component';
import {LoanSliderComponent} from '../../../loan/components/loan-slider/loan-slider.component';
import {LoanApplicationStepsComponent} from '../loan-application-steps/loan-application-steps.component';
import {ContactSectionComponent} from '../contact-section/contact-section.component';
import {Router} from "@angular/router";
import {SharedStateService} from "../../../core/services/shared-state.service";
import {PageBase} from "../../../core/components/page-base";

@Component({
  selector: 'app-homepage-single',
  templateUrl: './homepage-single.component.html',
  styleUrls: ['./homepage-single.component.scss'],
  imports: [
    PromoBannerComponent,
    LoanSliderComponent,
    LoanApplicationStepsComponent,
    ContactSectionComponent,
  ],
})
export class HomepageSingleComponent extends PageBase {
  protected sharedState = inject(SharedStateService);

  constructor() {
    super();
    effect(() => {
      if (this.sharedState.customerCurrentLoan()?.customerPin) {
        this.router.navigateByUrl("/customer/profile");
      }
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

}
